/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
var Paths = {
  HOME: '/',
  LOGIN: '/login'
};

/**
 * Provides access the the URLs that are mapped to each page via the route configuration in the
 * universal access library.
 */
export default Paths;